import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import _get from "lodash/get";
import _isArray from "lodash/isArray";
import _isEmpty from "lodash/isEmpty";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isString = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};

var isObject = function isObject(value) {
  return _typeof(value) === 'object';
};
/**
 *
 * Extract the string from the given structured content or
 * just return the string if it is a string.
 *
 *
 * @param {Any} structuredContent An array, object, string, or number
 * representing the content.
 *
 * @return {String} text content to be used
 *
 */


export var extractStructuredContent = function extractStructuredContent(structuredContent) {
  if (!structuredContent || _isEmpty(structuredContent)) {
    return '';
  }

  if (isString(structuredContent)) {
    return structuredContent;
  }

  if (_isArray(structuredContent)) {
    return structuredContent.map(function (content) {
      return extractStructuredContent(content);
    }).join(' ');
  }

  if (isObject(structuredContent)) {
    return extractStructuredContent(_get(structuredContent, 'props.children', ''));
  }

  return '';
};
export default {
  extractStructuredContent: extractStructuredContent
};